import React, { ReactElement, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../../components";
import { ORDER_DETAILS, ORDERS } from "../../../constants/routes";
import { useOrder } from "../../../hooks/api/v2/order/useOrder";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { SendMessage } from "../Message/OrderSendMessage";
import { OrderContentContainer } from "../OrderContent/OrderContentContainer";

export function AcceptedOrder({
  orderId,
}: {
  orderId: number;
}): ReactElement | null {
  const navigate = useNavigate();
  const { business } = useSellarCurrentBusiness();
  const scrollToRef = useRef<HTMLDivElement | null>(null);
  const orderQuery = useOrder(orderId, {
    onError: (e) => {
      if (e.response?.status === 404) return navigate(ORDERS);
    },
  });

  const order = orderQuery.data;
  const shouldShowRequestedOrder = Boolean(
    order && !order.acceptedAt && !order.cancelledAt && business?.Supplier,
  );

  useEffect(() => {
    if (orderQuery.isPending) return;

    if (!order) {
      navigate(ORDERS, { replace: true });
      return;
    }

    if (shouldShowRequestedOrder) {
      navigate(
        `${ORDER_DETAILS.href({ orderId: order.id })}?tab=Order+requests`,
        {
          replace: true,
        },
      );
    }
  }, [navigate, order, orderQuery.isPending, shouldShowRequestedOrder]);

  if (orderQuery.isPending) return <SpinnerLegacy />;
  if (!order || shouldShowRequestedOrder) return null;

  return (
    <>
      <OrderContentContainer order={order} />
      <div ref={scrollToRef} />
      <div className="sticky bottom-0 mx-auto mt-2 flex flex-col gap-2 bg-gray-100 px-2">
        <div className={"pb-5"}>
          <SendMessage
            orderId={orderId}
            onFocus={() => {
              scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
            }}
          />
        </div>
      </div>
    </>
  );
}
